import { parse as parseCookies } from 'cookie';

import type { ZoneConfig } from 'src/config';

export const overrideZoneFeatures = (zoneFeatures: ZoneConfig): ZoneConfig => {
  const cookie = parseCookies(window.document.cookie);
  return Object.entries(zoneFeatures).reduce<ZoneConfig>(
    (acc, [featureKey, value]) => {
      const cookieValue = cookie[featureKey]?.toLowerCase();
      const overrideValue = cookieValue
        ? cookieValue === 'true' || cookieValue === '1'
        : undefined;
      acc[featureKey as keyof ZoneConfig] = overrideValue ?? value;
      return acc;
    },
    {},
  );
};
